export const PANEL_PAGE_SIZE = 20;
export const PANEL_MENTION_USER_PAGE_SIZE = 200;

export function webChatPanelDetailsPath(chatId) {
  return `/web/chat/${chatId}/panel/details`;
}
export function webChatPanelUsersPath(chatId) {
  return `/web/chat/${chatId}/panel/users`;
}
export function webChatPanelMediaPath(chatId) {
  return `/web/chat/${chatId}/panel/media`;
}
export function webChatPanelDocumentsPath(chatId) {
  return `/web/chat/${chatId}/panel/documents`;
}
